import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { mergeCandidateKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import { mergeCandidatesContract, type MergeCandidatesResponse } from '@bliks-io/contracts';

/**
 * Fetch merge candidates for an assignment
 *
 * Returns completed step recordings eligible for merging, excluding the
 * assignment's source step. Only fetches when assignmentId is provided.
 */
export function useMergeCandidates(assignmentId: string | undefined) {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: mergeCandidateKeys.detail(assignmentId),
    queryFn: async ({ signal }): Promise<MergeCandidatesResponse> => {
      const { data } = await apiClient.get<MergeCandidatesResponse>(
        `${mergeCandidatesContract.path}?assignmentId=${assignmentId}`,
        { signal }
      );
      return data;
    },
    enabled: !!token && !!assignmentId
  });
}
